import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import {
  GET_PRODUCTION_DECLARATION_MATERIALS_KEY,
  UPDATE_PRODUCTION_DECLARATION_MATERIAL_STATUS_KEY,
} from '@/keys';
import type { ProductionDeclarationMaterialStatusCode } from '@/types/core/purchase-order/production-declaration-material-status-code';

type UpdateProductionDeclarationMaterialStatusVariables = {
  productionDeclarationId: string;
  materialId: string;
  status: ProductionDeclarationMaterialStatusCode;
  token?: string;
};

async function updateProductionDeclarationMaterialStatus({
  productionDeclarationId,
  materialId,
  status,
}: UpdateProductionDeclarationMaterialStatusVariables): Promise<void> {
  await api.patch(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/status`,
    { status },
  );
}

export function useUpdateProductionDeclarationMaterialStatus(): UseMutationResult<
  void,
  Error,
  UpdateProductionDeclarationMaterialStatusVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: UPDATE_PRODUCTION_DECLARATION_MATERIAL_STATUS_KEY,
    mutationFn: updateProductionDeclarationMaterialStatus,
    onSuccess: async (_data, { productionDeclarationId, token }) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_MATERIALS_KEY,
          productionDeclarationId,
          token ?? '',
        ],
      });
    },
  });
}
